/**
 * Universal function for searching across all object fields
 * Searches nested objects and arrays
 */
export const searchInData = (data, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return data;
  }

  const searchLower = searchTerm.toLowerCase().trim();

  const searchInValue = (value) => {
    if (value === null || value === undefined) {
      return false;
    }

    // If it's an object, recursively search in its fields
    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.values(value).some(val => searchInValue(val));
    }

    // If it's an array, search in elements
    if (Array.isArray(value)) {
      return value.some(item => searchInValue(item));
    }

    // For primitive values
    const stringValue = String(value).toLowerCase();
    return stringValue.includes(searchLower);
  };

  return data.filter(item => {
    // Search in all object fields
    return Object.values(item).some(value => searchInValue(value));
  });
};
